import {
  __name,
  __privateAdd,
  __privateGet,
  __privateSet
} from "./chunk-2IB33T4A.js";

// src/errors/permissions-not-fount.error.ts
var _PermissionsNotFoundError = class _PermissionsNotFoundError extends Error {
  constructor(categoryId) {
    super(`N\xE3o existe permiss\xF5es para a categoria ${categoryId}`);
    this.name = "PermissionsNotFoundError";
  }
};
__name(_PermissionsNotFoundError, "PermissionsNotFoundError");
var PermissionsNotFoundError = _PermissionsNotFoundError;

// src/errors/validation-user.error.ts
var _error;
var _ValidationUserError = class _ValidationUserError extends Error {
  constructor(error) {
    super("Erro ao validar usu\xE1rio");
    __privateAdd(this, _error);
    __privateSet(this, _error, error);
    this.stack = error.stack;
    this.name = error.name;
  }
  get issue() {
    return __privateGet(this, _error);
  }
};
_error = new WeakMap();
__name(_ValidationUserError, "ValidationUserError");
var ValidationUserError = _ValidationUserError;

export {
  PermissionsNotFoundError,
  ValidationUserError
};
//# sourceMappingURL=chunk-YYSNTNF7.js.map